export default __webpack_public_path__ + "static/feature-trends@2x-2210c07bf5ba2a6ba909078b1c4758e2.png";